import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { URLsConfig } from '../URLsConfig';
import { DecisionModel } from '../models/DecisionModel';



@Injectable()
export class DecisionService {
    constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
    }

    public getDecisionPatient(PatientCode: string) {
      let params = new HttpParams();
      params = params.append("PatientCode", PatientCode);
      const options = {
          params: params
      };
      return this.http.get<DecisionModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Decision/GetDecision_Patient', options);
    }
    public getDecision(PatientCode: string,DecDate:string ,userid:string) {
      let params = new HttpParams();
      params = params.append("DecDate", DecDate);
      params = params.append("PatientCode", PatientCode);
      params = params.append("userid", userid);
      const options = {
          params: params
      };
      return this.http.get<DecisionModel>(this.urlsconfig.WebAPIURL_Test + 'api/Decision/GetDecision', options);
    }
    public AddDecision(Decision: DecisionModel) {
            return this.http.post<DecisionModel>(this.urlsconfig.WebAPIURL_Test + 'api/Decision/AddDecision', Decision);
    }
    public deleteDecision(DecDate:string ,PatientCode: string,userid:string) {
      let params = new HttpParams();
      params = params.append("DecDate", DecDate);
      params = params.append("PatientCode", PatientCode);
      params = params.append("userid", userid);
      const options = {
          params: params
      };
      return this.http.get<DecisionModel>(this.urlsconfig.WebAPIURL_Test + 'api/Decision/DelDecision', options);
    }
}
